import React from "react";
import { Modal, Button, ButtonToolbar, Placeholder } from "rsuite";
interface Props {
  open: boolean,
  setOpen: Function,
  confirmDialogTitle?:string,
  confirmDialogMessage:string,
  confirmButtonText:string,
  cancelButtonText:string,
  onConfirm:Function
}

export const EPConfirmationDialog: React.FC<Props> = ({
  open,
  setOpen,
  confirmDialogTitle,
  confirmDialogMessage,
  confirmButtonText,
  cancelButtonText,
  onConfirm,
}) => {
  const handleClose = () => setOpen(false);

  const onAgree = () => {
    onConfirm();
    handleClose();
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        className="modal-sm"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>{confirmDialogTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{confirmDialogMessage}</Modal.Body>
        <Modal.Footer>
          <Button onClick={onAgree} appearance="primary">
            {confirmButtonText}
          </Button>
          <Button
            onClick={handleClose}
            className="cancel-btn"
            appearance="subtle"
          >
            {cancelButtonText}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
